import { useQuery } from '@tanstack/react-query';
import { getOfferingById } from '../api/offerings';

export function useOffering(id: string | null) {
  return useQuery({
    queryKey: ['offerings', id],
    queryFn: () => (id ? getOfferingById(id) : null),
    enabled: id !== null,
  });
}
